import { GET_MANUAL_KYC_IMAGE, GET_MANUAL_KYC_REQ, GET_MANUAL_KYC_SUCCESS, GET_MANUAL_KYC_ERROR, GET_MANUAL_KYC_IMAGE_RESET } from "../actionType";

const initialState = {
    isLoading: true,
    manualKycImage: null,
    manualKycValue: null,
    manualKycData: null,
    manualKycError: null
}

const manualKycReducer = (state = initialState, action: any) => {
    const { type, payload } = action;

    switch (type) {

        case GET_MANUAL_KYC_IMAGE:
            return {
                ...state,
                manualKycImage: payload
            }

        case GET_MANUAL_KYC_REQ:
            return {
                ...state,
                manualKycValue: payload
            }

        case GET_MANUAL_KYC_SUCCESS:
            return {
                ...state,
                isLoading: false,
                manualKycData: payload
            }

        case GET_MANUAL_KYC_ERROR:
            return {
                ...state,
                isLoading: false,
                manualKycError: payload
            }
        case GET_MANUAL_KYC_IMAGE_RESET:
            return {
                ...state,
                isLoading: false,
                manualKycImage: null
            }
        default:
            return {
                state
            }
    }
}

export default manualKycReducer